import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { checkCookie } from '../../utils/cookieService';

/**
 *
 * @type {React.NamedExoticComponent<{}>}
 */
const ProtectedRoute = ( { ...props } ) => {
    return (
        checkCookie( 'token' ) === true ?
            <Route path={ props.path }
                   component={ () => <props.component route={ props.route }/> }/>
            :
            <Redirect to='/login'/>
    );
} ;


export default ProtectedRoute;
